import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import regionConfig from "../../shared/regionConfig";

const apiBase = regionConfig.apiBase?.replace(/\/$/, "");
const newAPIBase = regionConfig.newAPIBase?.replace(/\/$/, "");

/**
 * Helper: run makeAuthedRequest and return an empty array
 * if the response is anything other than 200/201/204.
 */
const fetchJson = (req) =>
  req.then(async (res) => {
    if (res.status === 204) return [];
    if (!res.ok) return [];
    return res.json();
  });

export function useEmailLookup(email) {
  const { makeAuthedRequest } = Auth.useContainer();
  const { logError } = useLogger({ prefix: "useEmailLookup" });

  return useQuery(
    ["emailLookup", email],
    async () => {
      if (!email) return null;
      const enc = encodeURIComponent(email.trim());

      const wwgReq = fetchJson(
        makeAuthedRequest(
          `${apiBase}/membership/lookup/ibo?term=${enc}&limit=50`
        )
      );
      const dsReq = fetchJson(
        makeAuthedRequest(
          `${newAPIBase}/v1/dreamstream/support/dreamstream/email/${enc}/ibos`
        )
      );
      const tpReq = fetchJson(
        makeAuthedRequest(
          `${newAPIBase}/v1/topics/support/topics/email/${enc}/ibos`
        )
      );

      const [wwg, dreamStream, topics] = await Promise.all([
        wwgReq,
        dsReq,
        tpReq,
      ]);

      return { wwg, dreamStream, topics };
    },
    {
      enabled: !!email,
      onError: logError,
      staleTime: 0, // data is always stale
      cacheTime: 0, // don't keep any cache
      refetchOnMount: true,
    }
  );
}
